import { Button, Form, Input, Modal, Select, message } from "antd";
import DatePicker from "../../../../../components/inputs/MomentDatePicker";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useQuery } from "react-query";
import { useLocation } from "react-router-dom";
import { serverUrl } from "../../../../../nestserver";
import { selectUser, selectSchoolId } from "../../../../../redux/slices/auth.slice";
import StudentFeDetails from "./StudentFeeDetails";
import ViewTransactionHistory from "./ViewTransactionHistory";
import BackButton from "../../../../../components/buttons/BackButton";
const ViewStudentFee = () => {
  const getCurrentAcademicYear = () => {
    const today = new Date();
    const curYear = today.getFullYear();
    const curMonth = today.getMonth() + 1;
    const startYear = curMonth >= 6 ? curYear : curYear - 1;
    const endYearShort = String(startYear + 1).slice(-2);
    return `${startYear}-${endYearShort}`;
  };

  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const urlYear = searchParams.get("year") || getCurrentAcademicYear();

  const [form] = Form.useForm();
  const user = useSelector(selectUser);
  const { Option } = Select;
  let isViewStudentFee = true;
  const [OpenTransactionPopup, setOpenTransactionPopup] = useState(false);
  const [openTransactionHistory, setOpenTransactionHistory] = useState(false);
  const [classId, setClassId] = useState("");
  const [studentId, setStudentId] = useState("");
  const [studentFee, setStudentFee] = useState();
  const [transactionHistory, setTransactionHistory] = useState(null);
  const [studentFeeId, setStudentFeeId] = useState();
  const [selectedYear, setSelectedYear] = useState(urlYear);
  const [refreshKey, setRefreshKey] = useState(0);

  const [openMiscFeeModal, setOpenMiscFeeModal] = useState(false);
  const [miscFeeComponents, setMiscFeeComponents] = useState([{ name: "", amount: "" }]);
  const [miscFeeStudentFeeId, setMiscFeeStudentFeeId] = useState(null);
  const [miscFeeInstallmentId, setMiscFeeInstallmentId] = useState(null);
  const [savingMiscFee, setSavingMiscFee] = useState(false);
  const [firstUnpaidRemaining, setFirstUnpaidRemaining] = useState(null);

  const schoolId = useSelector(selectSchoolId);
  const authHeader = { Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}` };
  const { data: schoolData } = useQuery(
    ["school-info-viewsf", schoolId],
    () => axios.get(`${serverUrl}/school/${schoolId}`, { headers: authHeader }).then(r => r.data?.result?.data),
    { enabled: !!schoolId }
  );
  const isManualMode = schoolData?.is_manual_fee_assignment_enabled === true;

  function disabledDate(current) {
    return current && current > moment().endOf("day");
  }
  const fetchStudentFee = async () => {
    await axios({
      method: "get",
      url:
        serverUrl +
        "/admin/fee-template/class/" +
        classId +
        "/student/" +
        studentId,
      params: {
        year: selectedYear,
      },
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    })
      .then((response) => {
        if (response?.data?.result && response?.data?.result.length > 0) {
          const firstData = response?.data?.result[0];
          const transportation = response?.data?.result?.find(
            (data) => data?.fee_template?.type === "transportation",
          );
          const accommodation = response?.data?.result?.find(
            (data) => data?.fee_template?.type === "accommodation",
          );

          if (transportation) {
            form.setFieldsValue({
              transportation: transportation?.fee_template?._id,
            });
          }
          if (accommodation) {
            form.setFieldsValue({
              accommodation: accommodation?.fee_template?._id,
            });
          }
          form.setFieldsValue({
            name: `${firstData?.student?.first_name} ${firstData?.student?.last_name}`,
            studentFullName: `${firstData?.student?.first_name} ${firstData?.student?.last_name}`,
            studentId: firstData?.student?.unique_id,
            studentStudentId: firstData?.student?.unique_id,
            class: firstData?.class?.name,
            parent: `${firstData?.student?.parent?.first_name} ${firstData?.student?.parent?.last_name}`,
            phone: firstData?.student?.parent?.phone,
          });
        }

        setStudentFee(response?.data?.result);
      })
      .catch((error) => {
        console.error("Error fetching student fee:", error);
      });
  };

  useEffect(() => {
    if (classId && studentId) {
      fetchStudentFee();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [classId, studentId, selectedYear]);
  const onFinish = (values) => {
    const feeType = form.getFieldValue("feeType");

    // Requirement 5: collection must not exceed remaining at any point
    const remaining = Number(form.getFieldValue("remaining") || 0);
    const payment = Number(values?.payment || 0);
    if (payment <= 0) {
      message.error("Payment amount must be greater than zero.");
      return;
    }
    if (payment > remaining) {
      message.error(
        `Payment amount (₹${payment.toLocaleString()}) cannot exceed the remaining balance (₹${remaining.toLocaleString()}).`,
      );
      return;
    }

    const transactionPayload = {
      name: values?.fullName,
      type: values?.paymentType,
      amount: values?.payment,
      date: (() => {
        const picked = moment(values?.date);
        const isToday = picked.isSame(moment(), "day");
        return isToday
          ? moment().toISOString()
          : picked.set({ hour: 12, minute: 0, second: 0, millisecond: 0 }).toISOString();
      })(),
      feeCategory: feeType?.endsWith("_other") ? "other" : "tuition",
    };
    if (studentFeeId) {
      axios
        .post(
          serverUrl + "/admin/student-fee/" + studentFeeId + "/transaction",
          transactionPayload,
          {
            headers: {
              Authorization: `Bearer ${window.localStorage.getItem(
                "jwt-token",
              )}`,
            },
          },
        )
        .then((response) => {
          form.setFieldsValue({
            fullName: undefined,
            payment: undefined,
            paymentType: undefined,
            date: undefined,
            feeType: undefined,
            totalFee: undefined,
            paid: undefined,
            remaining: undefined,
          });
          message.success(response?.data?.result?.message);
          setOpenTransactionPopup(false);
          setFirstUnpaidRemaining(null);
          fetchStudentFeeHistory();
          fetchStudentFee();
          setRefreshKey((k) => k + 1);
        })
        .catch((err) => {
          if (err?.response?.data?.error?.errors) {
            message.error(err?.response?.data?.error?.errors);
          }
        });
    }
  };
  const handleOpenMiscFeeModal = () => {
    const tuitionRecord = studentFee?.find(
      (sf) => sf?.fee_template?.type?.toLowerCase() === "tution",
    );
    if (!tuitionRecord) {
      message.error("No tuition fee record found for this student.");
      return;
    }
    // Requirement 1: Work even when no "Other Fee" installment exists yet.
    const otherFeeInst = tuitionRecord?.installment_list?.find(
      (i) => i.name?.toLowerCase() === "other fee",
    );

    // Pre-fill existing components (exclude total_amount); start with one blank row if none
    const comp = otherFeeInst?.payable_components?.[0] || otherFeeInst?.payable_components || {};
    const existing = Object.entries(comp)
      .filter(([key]) => key !== "total_amount")
      .map(([key, val]) => ({ name: key, amount: String(val), isSaved: true }));

    setMiscFeeComponents(existing.length > 0 ? existing : [{ name: "", amount: "" }]);
    setMiscFeeStudentFeeId(tuitionRecord._id);
    // null _id signals backend to create a new Other Fee installment
    setMiscFeeInstallmentId(otherFeeInst?._id || null);
    setOpenMiscFeeModal(true);
  };

  const handleSaveMiscFee = async () => {
    const filled = miscFeeComponents.filter((c) => c.name.trim() && c.amount !== "");
    if (filled.length === 0) {
      message.error("Add at least one fee component with a name and amount.");
      return;
    }
    const hasDuplicate = filled.some(
      (c, i) => filled.findIndex((x) => x.name.trim().toLowerCase() === c.name.trim().toLowerCase()) !== i,
    );
    if (hasDuplicate) {
      message.error("Duplicate fee component names are not allowed.");
      return;
    }
    const hasInvalid = filled.some((c) => isNaN(Number(c.amount)) || Number(c.amount) < 0);
    if (hasInvalid) {
      message.error("All amounts must be valid non-negative numbers.");
      return;
    }

    const payable_components = {};
    filled.forEach((c) => {
      payable_components[c.name.trim()] = Number(c.amount);
    });

    setSavingMiscFee(true);
    try {
      await axios.patch(
        `${serverUrl}/admin/student-fee/${miscFeeStudentFeeId}/installments/`,
        { _id: miscFeeInstallmentId, payable_components },
        {
          headers: {
            Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
          },
        },
      );
      message.success("Miscellaneous fees updated successfully.");
      setOpenMiscFeeModal(false);
      setRefreshKey((k) => k + 1);
      fetchStudentFee();
    } catch (err) {
      message.error(err?.response?.data?.message || "Failed to save miscellaneous fees.");
    } finally {
      setSavingMiscFee(false);
    }
  };

  const miscFeeTotal = miscFeeComponents.reduce(
    (sum, c) => sum + (parseFloat(c.amount) || 0),
    0,
  );

  const fetchStudentFeeHistory = async () => {
    await axios({
      method: "get",
      url:
        serverUrl + "/admin/student-fee/" + studentId + "/transaction-history",
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem("jwt-token")}`,
      },
    })
      .then((response) => {
        setTransactionHistory(response?.data?.result);
      })
      .catch((err) => {
        // if (err?.response?.data?.error?.errors) {
        //   message.error(err?.response?.data?.error?.errors);
        // }
      });
  };

  const handleFeeTypeChange = (value) => {
    const isOther = value.endsWith("_other");
    const templateId = isOther ? value.slice(0, -6) : value;

    const feeTypeData = studentFee?.find(
      (data) => data?.fee_template?._id === templateId,
    );
    setStudentFeeId(feeTypeData ? feeTypeData?._id : "");

    if (!feeTypeData) {
      form.setFieldsValue({
        totalFee: 0,
        paid: 0,
        remaining: 0,
        user: `${user?.admin?.first_name} ${user?.admin?.last_name}` || "",
      });
      return;
    }

    const otherFeeInst = feeTypeData?.installment_list?.find(
      (inst) => inst.name?.toLowerCase() === "other fee"
    );

    if (isOther) {
      const otherTotal = otherFeeInst
        ? (otherFeeInst.payable_components?.[0]?.total_amount || otherFeeInst.payable_components?.total_amount || 0)
        : 0;
      const otherPaid = otherFeeInst?.paid || 0;
      const otherRemaining = otherFeeInst?.remaining || 0;

      form.setFieldsValue({
        totalFee: otherTotal,
        paid: otherPaid,
        remaining: otherRemaining,
        user: `${user?.admin?.first_name} ${user?.admin?.last_name}` || "",
      });
    } else {
      const otherTotal = otherFeeInst
        ? Number(
            otherFeeInst.payable_components?.[0]?.total_amount ||
              otherFeeInst.payable_components?.total_amount ||
              0,
          )
        : 0;
      const otherPaid = otherFeeInst?.paid || 0;
      const otherRemaining = otherFeeInst?.remaining || 0;

      const originalTotal =
        Number(feeTypeData?.total || 0) +
        Number(feeTypeData?.discount || 0) -
        Number(feeTypeData?.additional || 0);

      const tuitionTotal = originalTotal - otherTotal;
      const tuitionPaid = Number(feeTypeData?.paid || 0) - otherPaid;
      const tuitionRemaining = Number(feeTypeData?.remaining || 0) - otherRemaining;

      form.setFieldsValue({
        totalFee: tuitionTotal,
        paid: tuitionPaid,
        remaining: tuitionRemaining,
        user: `${user?.admin?.first_name} ${user?.admin?.last_name}` || "",
      });

      if (isManualMode) {
        const firstUnpaid = (feeTypeData?.installment_list || []).find(
          (inst) => Number(inst.remaining) > 0 && inst.name?.toLowerCase() !== "other fee"
        );
        const lockAmount = firstUnpaid ? Number(firstUnpaid.remaining) : null;
        setFirstUnpaidRemaining(lockAmount);
        if (lockAmount !== null) {
          form.setFieldsValue({ payment: lockAmount });
        }
      } else {
        setFirstUnpaidRemaining(null);
      }
    }
  };

  useEffect(() => {
    if (studentFee) {
      fetchStudentFeeHistory();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentFee]);

  useEffect(() => {
    const urlParts = window.location.pathname.split("/");
    const classIdIndex = urlParts.indexOf("class");
    const studentIdIndex = urlParts.indexOf("student");

    if (classIdIndex !== -1 && studentIdIndex !== -1) {
      setClassId(urlParts[classIdIndex + 1]);
      setStudentId(urlParts[studentIdIndex + 1]);
    }
  }, []);

  return (
    <div className="student-form-fee">
      <div className="p-8">
        <div className="bg-white p-10 rounded-2xl">
          <div className="p-4 text-right">
            <BackButton />
          </div>
          <Form
            layout="vertical"
            name="basic"
            form={form}
            initialValues={{ remember: true }}
            autoComplete="off"
          >
            <div className="form-grid">
              <Form.Item label="Name" name="name">
                <Input disabled />
              </Form.Item>
              <Form.Item label="Student Id" name="studentId">
                <Input disabled />
              </Form.Item>
              <Form.Item label="Class" name="class">
                <Input disabled />
              </Form.Item>
            </div>
            <div className="form-grid">
              <Form.Item label="Parent" name="parent">
                <Input disabled />
              </Form.Item>
              <Form.Item label="Phone" name="phone">
                <Input disabled />
              </Form.Item>
            </div>
          </Form>
          <Form
            layout="vertical"
            name="basic"
            form={form}
            initialValues={{ remember: true }}
            autoComplete="off"
          >
            <div>
              <div className="flex justify-center gap-8">
                <div className="bg-white pt-4 rounded-2xl flex justify-between gap-4">
                  <Button
                    size="large"
                    style={{ backgroundColor: "#09617e", color: "white", fontWeight: 600, paddingInline: 28 }}
                    onClick={() => {
                      setStudentFeeId(undefined);
                      form.resetFields(["feeType", "totalFee", "paid", "remaining", "payment"]);
                      setOpenTransactionPopup(true);
                    }}
                  >
                    Collect Fee
                  </Button>
                </div>
                <div className="bg-white pt-4 rounded-2xl flex justify-between gap-4">
                  <Button
                    style={{ backgroundColor: "#f59e0b", color: "white" }}
                    onClick={handleOpenMiscFeeModal}
                    disabled={
                      !studentFee?.some(
                        (sf) => sf?.fee_template?.type?.toLowerCase() === "tution",
                      )
                    }
                  >
                    Add Misc Fee
                  </Button>
                </div>
                <div className="flex justify-center pt-4 items-center">
                  <Button
                    class
                    onClick={() => {
                      setOpenTransactionHistory(true);
                      fetchStudentFeeHistory();
                    }}
                  >
                    Transaction History
                  </Button>
                </div>
              </div>

              <StudentFeDetails
                feeResponse={studentFee}
                isViewStudentFee={isViewStudentFee}
                fetchStudentFee={fetchStudentFee}
                classId={classId}
                studentId={studentId}
                refreshKey={refreshKey}
              />
            </div>
          </Form>
        </div>
      </div>

      <Modal
        width={760}
        layout="vertical"
        visible={OpenTransactionPopup}
        onOk={() => setOpenTransactionPopup(false)}
        onCancel={() => {
          setOpenTransactionPopup(false);
          form.setFieldsValue({
            fullName: undefined,
            payment: undefined,
            paymentType: undefined,
            date: undefined,
          });
        }}
        footer={null}
      >
        <div className="">
          <h3 className="text-lg font-bold pb-3">Collect Fee</h3>
          <Form
            layout="vertical"
            name="basic"
            form={form}
            initialValues={{ remember: true }}
            autoComplete="off"
            onFinish={onFinish}
          >
            <div className="bg-white pt-2 rounded-2xl">
              <div className="form-grid-2">
                <Form.Item
                  label="Name"
                  name="fullName"
                  style={{ fontWeight: "bold" }}
                >
                  <Input placeholder="Enter name" />
                </Form.Item>
                <Form.Item label="Class" name="class">
                  <Input disabled />
                </Form.Item>
                <Form.Item
                  label="Fee Type"
                  name="feeType"
                  style={{ fontWeight: "bold" }}
                  rules={[
                    {
                      required: true,
                      message: "Fee Type is required",
                    },
                  ]}
                >
                  <Select
                    showSearch
                    showArrow
                    placeholder="Select fee type"
                    className="w-full bg-gray-300 capitalize"
                    style={{
                      border: "6px",
                      backgroundColor: "#EBEBEB",
                    }}
                    getPopupContainer={(trigger) => trigger.parentNode}
                    onChange={handleFeeTypeChange}
                  >
                    {studentFee
                      ?.filter((data) => data.fee_template)
                      .flatMap((data) => {
                        const hasOtherFee = data?.installment_list?.some(
                          (inst) => inst.name?.toLowerCase() === "other fee"
                        );
                        const isTution = data?.fee_template?.type?.toLowerCase() === "tution";
                        if (isTution && hasOtherFee) {
                          return [
                            <Option
                              key={data?.fee_template?._id}
                              value={data?.fee_template?._id}
                            >
                              Tuition Fee
                            </Option>,
                            <Option
                              key={`${data?.fee_template?._id}_other`}
                              value={`${data?.fee_template?._id}_other`}
                            >
                              Miscellaneous Fees
                            </Option>
                          ];
                        } else {
                          const type = data?.fee_template?.type;
                          const displayType = type?.toLowerCase() === "tution"
                            ? "Tuition Fee"
                            : type?.toLowerCase() === "other fee"
                            ? "Miscellaneous Fees"
                            : type;
                          return [
                            <Option
                              key={data?.fee_template?._id}
                              value={data?.fee_template?._id}
                            >
                              {displayType}
                            </Option>
                          ];
                        }
                      })}
                  </Select>
                </Form.Item>

                <Form.Item label="Total Amount" name="totalFee">
                  <Input type="number" min={0} disabled />
                </Form.Item>
                <Form.Item label="Total Paid" name="paid">
                  <Input type="number" min={0} disabled />
                </Form.Item>
                <Form.Item label="Total Remaining" name="remaining" >
                  <Input type="number" min={0} disabled />
                </Form.Item>
                <Form.Item
                  label="Payment"
                  name="payment"
                  style={{ fontWeight: "bold" }}
                  rules={[
                    {
                      required: true,
                      message: "Payment is required",
                    },
                  ]}
                  extra={isManualMode ? "Full installment payment required" : undefined}
                >
                  <Input
                    type="number"
                    min={0}
                    placeholder="Enter amount"
                    onWheel={(e) => e.target.blur()}
                    readOnly={isManualMode && firstUnpaidRemaining !== null}
                    style={isManualMode && firstUnpaidRemaining !== null ? { backgroundColor: "#f5f5f5", cursor: "not-allowed" } : undefined}
                  />
                </Form.Item>
                <Form.Item
                  label="Type"
                  name="paymentType"
                  style={{ fontWeight: "bold" }}
                  rules={[
                    {
                      required: true,
                      message: "Payment Type is required",
                    },
                  ]}
                >
                  <Select
                    getPopupContainer={(trigger) => trigger.parentNode}
                    placeholder="Select mode"
                  >
                    <Select.Option value="cash">Cash</Select.Option>
                    <Select.Option value="card">Card</Select.Option>
                    <Select.Option value="online">Online</Select.Option>
                  </Select>
                </Form.Item>
                <Form.Item label="Date" name="date"  style={{ fontWeight: "bold" }} >
                  <DatePicker
                    format="DD-MM-YYYY"
                    getPopupContainer={(trigger) => trigger.parentNode}
                    className="w-full"
                    disabledDate={disabledDate}
                  />
                </Form.Item>
                <Form.Item label="User" name="user">
                  <Input disabled />
                </Form.Item>
              </div>
              <div className="flex justify-center items-center py-5">
                <div className="inline-flex items-center space-x-2">
                  <Button
                    size="large"
                    type="primary"
                    htmlType="submit"
                    className="text-white"
                  >
                    Complete
                  </Button>
                  <Button
                    size="large"
                    type="dark"
                    onClick={() => {
                      setOpenTransactionPopup(false);
                      setFirstUnpaidRemaining(null);
                      form.setFieldsValue({
                        fullName: undefined,
                        payment: undefined,
                        paymentType: undefined,
                        date: undefined,
                      });
                    }}
                  >
                    Cancel
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </Modal>

      <Modal
        width={1300}
        layout="vertical"
        visible={openTransactionHistory}
        onOk={() => setOpenTransactionHistory(false)}
        onCancel={() => {
          setOpenTransactionHistory(false);
        }}
        footer={null}
      >
        <ViewTransactionHistory
          transactionHistory={transactionHistory}
          studentId={studentId}
        />
      </Modal>

      {/* Add / Edit Miscellaneous Fees Modal */}
      <Modal
        title="Add / Edit Miscellaneous Fees"
        visible={openMiscFeeModal}
        onCancel={() => setOpenMiscFeeModal(false)}
        footer={null}
        width={580}
        destroyOnClose
      >
        <div className="flex flex-col gap-4 py-2">
          {/* Column headers */}
          <div className="flex gap-3 items-center">
            <div className="flex-1 text-sm font-semibold text-gray-600">
              Fee Component Name
            </div>
            <div style={{ width: 140 }} className="text-sm font-semibold text-gray-600">
              Amount (₹)
            </div>
            <div style={{ width: 72 }} />
          </div>

          {/* Component rows */}
          {miscFeeComponents.map((comp, idx) => (
            <div key={idx} className="flex gap-3 items-center">
              <Input
                className="flex-1"
                placeholder="e.g. Library, Lab, Sports"
                value={comp.name}
                disabled={comp.isSaved}
                onChange={(e) => {
                  const updated = miscFeeComponents.map((c, i) =>
                    i === idx ? { ...c, name: e.target.value } : c,
                  );
                  setMiscFeeComponents(updated);
                }}
              />
              <Input
                style={{ width: 140 }}
                type="number"
                min={0}
                placeholder="0"
                value={comp.amount}
                disabled={comp.isSaved}
                onChange={(e) => {
                  const updated = miscFeeComponents.map((c, i) =>
                    i === idx ? { ...c, amount: e.target.value } : c,
                  );
                  setMiscFeeComponents(updated);
                }}
                onKeyDown={(e) => {
                  if (e.key === "ArrowUp" || e.key === "ArrowDown") e.preventDefault();
                }}
                onWheel={(e) => e.target.blur()}
              />
              <Button
                danger
                style={{ width: 72 }}
                onClick={() =>
                  setMiscFeeComponents(miscFeeComponents.filter((_, i) => i !== idx))
                }
                disabled={comp.isSaved || miscFeeComponents.length === 1}
              >
                Remove
              </Button>
            </div>
          ))}

          {/* Add row button */}
          <Button
            type="dashed"
            onClick={() =>
              setMiscFeeComponents([...miscFeeComponents, { name: "", amount: "" }])
            }
          >
            + Add Component
          </Button>

          {/* Running total */}
          <div
            style={{
              padding: "10px 14px",
              background: "#f0fdf4",
              border: "1px solid #bbf7d0",
              borderRadius: 6,
            }}
            className="flex justify-between items-center"
          >
            <span className="text-sm font-semibold text-gray-700">Total Misc Fee</span>
            <span className="text-base font-bold text-green-700">
              ₹{miscFeeTotal.toLocaleString()}
            </span>
          </div>

          {/* Action buttons */}
          <div className="flex justify-end gap-3 pt-2">
            <Button onClick={() => setOpenMiscFeeModal(false)}>Cancel</Button>
            <Button
              type="primary"
              loading={savingMiscFee}
              onClick={handleSaveMiscFee}
              style={{ backgroundColor: "#f59e0b", borderColor: "#f59e0b" }}
            >
              Save
            </Button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ViewStudentFee;
